<template>
  <div class="loading-overlay" :class="overlayClasses">
    <div class="loading-spinner">
      <div class="spinner" :class="spinnerClasses">
        <font-awesome-icon icon="fa-solid fa-spinner" spin />
      </div>
      <p v-if="message" class="loading-message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    message: {
      type: String,
      default: 'Loading...'
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].includes(value)
    },
    backdrop: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    overlayClasses() {
      return {
        'loading-overlay--no-backdrop': !this.backdrop
      }
    },
    spinnerClasses() {
      return [`spinner--${this.size}`]
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(2px);
  z-index: 1000;
}

.loading-overlay--no-backdrop {
  background-color: transparent;
  backdrop-filter: none;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.spinner {
  color: #3b82f6;
}

.spinner--small {
  font-size: 1rem;
}

.spinner--medium {
  font-size: 1.5rem;
}

.spinner--large {
  font-size: 2rem;
}

.loading-message {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
  text-align: center;
}
</style> 